WB.Utility = WB.Utility || {};
WB.Utility.Share = function ($location) {

    var _this = this;

    this.SocialConfig = {
        'facebook': {
            type: 'facebook',
            label: 'Facebook',
            color: '#3b5998',
            url: 'https://www.facebook.com/sharer/sharer.php?u={url}',
            win: {
                height: 300,
                width: 600
            }
        },
        'twitter': {
            type: 'twitter',
            label: 'Twitter',
            color: '#55acee',
            url: 'https://twitter.com/intent/tweet?text={text}&url={url}',
            win: {
                height: 300,
                width: 600
            }
        },
        'google-plus': {
            type: 'google-plus',
            label: 'Google Plus',
            color: '#dd4b39',
            url: 'https://plus.google.com/share?url={url}',
            win: {
                height: 370,
                width: 500
            }
        },
        'email': {
            type: 'email',
            label: 'Email',
            color: '#aaa',
            url: 'mailto:?subject={subject}&body={text}%20%20{url}',
            win: {
                height: 480,
                width: 640
            }
        }
    };

    this.GeneratePlatformUrl = function(platform, shareData) {
        var url = shareData.url;

        if (!url && shareData.path) {
            url = $location.protocol() + '://' + $location.host() + (shareData.path.startsWith('/') ? '' : '/') + shareData.path;
        }

        if (!url) {
            url = document.URL;
        }

        var data = { url: encodeURIComponent(url) };

        if (shareData.text) {
            data.text = encodeURIComponent(shareData.text);
        }

        data.subject = shareData.subject;

        return L.Util.template(_this.SocialConfig[platform].url, data);
    };

    this.OpenUrlWindow = function(platform, options, e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }

        var settings = angular.extend({
            path: null,
            url: null,
            text: null,
            subject: null,
            height: _this.SocialConfig[platform].win.height,
            width: _this.SocialConfig[platform].win.width
        }, options || {});

        var platformUrl = _this.GeneratePlatformUrl(platform, settings);

        if(platform == 'email') {
            window.location.assign(platformUrl);
        }
        else {
            // Fixes dual-screen position                         Most browsers      Firefox
            var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
            var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
    
            width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    
            var left = ((width / 2) - (settings.width / 2)) + dualScreenLeft;
            var top = ((height / 2) - (settings.height / 2)) + dualScreenTop;
        
            window.open(platformUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' + settings.height + ',width=' + settings.width + 'top='+top+',left='+left);
        }
       
    };

};
WB.Utility.Share.$inject = ['$location'];

WB.Core.service('Share', WB.Utility.Share);
